import type { MessageKey } from 'types/LocaleMessageKey';

// Discount messages
export const MESSAGE_SUCCESS_DEFAULT: MessageKey = 'pdp_discount_applied';
export const MESSAGE_HIGHEST_DISCOUNT: MessageKey =
  'sitewide_highest_discount_eyebrow_copy';
export const MESSAGE_ERROR_USED: MessageKey = 'pdp_discount_error_used';
export const MESSAGE_ERROR_EXPIRED: MessageKey = 'pdp_discount_error_expired';
export const MESSAGE_ERROR_DEFAULT: MessageKey = 'pdp_discount_error';

// Discount error types
export const ERROR_EXPIRED = 'expired';
export const ERROR_NO_USES_REMAIN = 'no_uses_remaining';
export const ERROR_NOT_FOUND = 'not_found';

// Local storage key for locally applied promotion code
export const PROMOTION_CODE = 'promotion_code';
